import { environment } from 'src/environment';
import { Component, OnInit, Inject, PLATFORM_ID, HostListener, OnDestroy } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Router } from '@angular/router';
import { ConfigurationService } from 'src/app/core/services/configuration.service';
import { BaseService, SettingsService, StorageService } from 'src/app/core/services';

@Component({
  selector: 'app-where-to-watch',
  templateUrl: './where-to-watch.component.html',
  styleUrls: ['./where-to-watch.component.scss']
})
export class WhereToWatchComponent implements OnInit {
  deviceUrl;
  deviceLogoUrl;
  isMobile;
  logged_in;
  logo;
  locale;
  device1 = {};
  device2 = {};
  device3 = {};
  device4 = {};
  device5 = {};
  samrtTVInfo = [];
  setTopBoxInfo = [];
  mediaPlayerInfo = [];
  smartphoneInfo = [];
  faqKey;
  plans;
  appName;
  planInfo;
  contentData = {smartTv: true, setTopBox:false, mediaPlayer: false, smartphone: false,pcLaptop : false};
  skinName = environment.skinName;
constructor(  
  @Inject(PLATFORM_ID) private platformId: object,
  public router: Router, public configService: ConfigurationService, private storageService: StorageService,
  private settingsService: SettingsService, private baseService:BaseService
  ) { }

  async ngOnInit() {
    this.planInfo = localStorage.getItem('planInfo');
    this.logged_in = this.storageService.getLocalStore('u_id');
    this.logo = this.settingsService.logo;
    if(!this.logged_in){
      this.settingsService.showHeader = false;
    }
    this.isMobile = this.baseService.isMobileOrNot();
    this.appName = environment.apiAppName;
    if(this.appName == 'filmbox' || this.appName == 'film1') {
      this.deviceUrl = "https://filmboxcustomerassets.s3.eu-central-1.amazonaws.com/Where-to-Watch/";
      this.deviceLogoUrl = "https://filmboxcustomerassets.s3.eu-central-1.amazonaws.com/Where-to-Watch/Logo/";
    } else{
      this.deviceUrl = this.settingsService.imagePath+'Where-to-Watch/'
      this.deviceLogoUrl = this.settingsService.imagePath+'Where-to-Watch/Logo/';
    }
    await this.getTranslations();
    
  }

  getTranslations() {
    this.device1 = {
      'device_type': this.configService.localeKeys?.["where_to_watch.smart_tv.title"],
      'device_backbone_img': `../../../branding/theme/assets/static_assets/ic-smart-tv.svg`,
      'device_description': this.configService.localeKeys?.["where_to_watch.smart_tv.text"],
      'device_logo1': [this.deviceLogoUrl+'lg-logo.svg', 'lg_tv'],
      'device_logo2': [this.deviceLogoUrl+'samsung-tv-logo.svg', 'samsung_tv'],
      'device_logo3': '',
      'device_logo4': '',
      'type_slug': 'tv_content',
    }
  
    this.device2 = {
      'device_type': this.configService.localeKeys?.["where_to_watch.set_top_box.title"],
      'device_backbone_img':  `../../../branding/theme/assets/static_assets/ic-setup-box.svg`,
      'device_description': this.configService.localeKeys?.["where_to_watch.set_top_box.title"],
      'device_logo1': [this.deviceLogoUrl+'vodafone-tv.svg', 'vtv'],
      'device_logo2': '',
      'device_logo3': '',
      'device_logo4': '',
      'type_slug': 'settopbox_content'
    }
  
    this.device3 = {
      'device_type': this.configService.localeKeys?.["where_to_watch.streaming_media_player.title"],
      'device_backbone_img':  `../../../branding/theme/assets/static_assets/ic-smartbox.svg`,
      'device_description': this.configService.localeKeys?.["where_to_watch.streaming_media_player.desc"],
      'device_logo1': [this.deviceLogoUrl+'android-tv-logo.svg', 'android_media'],
      'device_logo2': [this.deviceLogoUrl+'apple-tv-logo.svg', 'apple_media'],
      'device_logo3': [this.deviceLogoUrl+'chromecast.svg', 'chromecast_media'],
      'device_logo4': [this.deviceLogoUrl+'airplay.svg', 'airplay_media'],
      'type_slug': 'media_content'
    }
  
    this.device4 = {
      'device_type': this.configService.localeKeys?.["where_to_watch.smartphones_tablets.title"],
      'device_backbone_img':  `../../../branding/theme/assets/static_assets/ic-tablet-and-mobile.svg`,
      'device_description': this.configService.localeKeys?.["where_to_watch.smartphones_tablets.desc"],
      'device_logo1': [this.deviceLogoUrl+'ios-mobile-logo.svg', 'ios_phone'],
      'device_logo2': [this.deviceLogoUrl+'android-mobile-logo.svg', 'android_phone'],
      'device_logo3': '',
      'device_logo4': '',
      'type_slug': 'smartdevice_content'
    }
  
    this.device5 = {
      'device_type': this.configService.localeKeys?.["where_to_watch.pc_laptops.title"],
      'device_backbone_img':  `../../../branding/theme/assets/static_assets/ic-where-to-watch-laptop.svg`,
      'device_description': this.configService.localeKeys?.["where_to_watch.pc_laptops.title_desc"],
      'device_logo1': '',
      'device_logo2': '',
      'device_logo3': '',
      'device_logo4': '',
      'type_slug': 'laptop_content'
    }
  
  
    this.samrtTVInfo = [
      {
        'device_name': this.configService.localeKeys?.["where_to_watch.lg_caps.title"],
        'device_logo': this.deviceLogoUrl+'lg-logo.svg',
        'device_desc': this.configService.localeKeys?.["where_to_watch.lg_desc.part1.text"],
        'device_para': this.configService.localeKeys?.["where_to_watch.lg_desc.part2.text"],
        'device_main_img': 'https://www.youtube.com/embed/tgbNymZ7vqY?autoplay=1&mute=1',
        'type_slug': 'lg_tv',
        'image_name':'LG',
        'image_type':'LG',
        'device_steps': [
          {
            'stepImg': this.deviceUrl,
            'stespDesc': this.configService.localeKeys?.["where_to_watch.lg.point1.text"]
          },
          {
            'stepImg': this.deviceUrl,
            'stespDesc': this.configService.localeKeys?.["where_to_watch.lg.point2.text"]
          },
          {
            'stepImg': this.deviceUrl,
            'stespDesc': this.configService.localeKeys?.["where_to_watch.lg.point3.text"]
          },
          {
            'stepImg': this.deviceUrl,
            'stespDesc': this.configService.localeKeys?.["where_to_watch.lg.point4.text"]
          }
        ]
      },
      {
      'device_name': this.configService.localeKeys?.["where_to_watch.samsung.title"],
      'device_logo': this.deviceLogoUrl+'samsung-tv-logo.svg',
      'device_desc': this.configService.localeKeys?.["where_to_watch.samsung_desc_part1.text"],
      'device_para': this.configService.localeKeys?.["where_to_watch.samsung_desc_part2.text"],
      'device_main_img': 'https://www.youtube.com/embed/tgbNymZ7vqY?autoplay=1&mute=1',
      'type_slug': 'samsung_tv',
      'image_name': 'Samsung',
      'image_type':'Samsung',
      'device_steps': [
        {
          'stepImg': this.deviceUrl,
          'stespDesc': this.configService.localeKeys?.["where_to_watch.samsung.point1.text"]
        },
        {
          'stepImg': this.deviceUrl,
          'stespDesc': this.configService.localeKeys?.["where_to_watch.samsung.point2.text"]
        },
        {
          'stepImg': this.deviceUrl,
          'stespDesc': this.configService.localeKeys?.["where_to_watch.samsung.point3.text"]
        },
        {
          'stepImg': this.deviceUrl,
          'stespDesc': this.configService.localeKeys?.["where_to_watch.samsung.point4.text"]
        }
      ]
    }
  ];
  
  this.setTopBoxInfo= [
    {
      'device_name': this.appName === 'filmbox' ? this.configService.localeKeys?.["where_to_watch.vodafone_tv.title"] : this.configService.localeKeys?.["where_to_watch.ziggo_tv.title"],
      'device_logo': this.deviceLogoUrl+'vodafone-tv.svg',
      'device_desc': this.appName === 'filmbox' ? this.configService.localeKeys?.["where_to_watch.vodafone_tv.part1.text"] : this.configService.localeKeys?.["where_to_watch.ziggo_tv.part1.text"],
      'device_para': this.appName === 'filmbox' ? this.configService.localeKeys?.["where_to_watch.vodafone_tv.part2.text"] : this.configService.localeKeys?.["where_to_watch.ziggo_tv.part2.text"],
      'device_main_img': 'https://www.youtube.com/embed/tgbNymZ7vqY?autoplay=1&mute=1',
      'type_slug': 'vtv',
      // 'device_steps': [
      //   {
      //     'stepImg': '../../../../branding/theme/assets/static_assets/device-steps.svg',
      //     'stespDesc': this.configService.localeKeys?.["where_to_watch.vodafone_tv.point1.text"]
      //   },
      //   {
      //     'stepImg': '../../../../branding/theme/assets/static_assets/device-steps.svg',
      //     'stespDesc': this.configService.localeKeys?.["where_to_watch.vodafone_tv.point2.text"]
      //   },
      //   {
      //     'stepImg': '../../../../branding/theme/assets/static_assets/device-steps.svg',
      //     'stespDesc': this.configService.localeKeys?.["where_to_watch.vodafone_tv.point3.text"]
      //   },
      //   {
      //     'stepImg': '../../../../branding/theme/assets/static_assets/device-steps.svg',
      //     'stespDesc': this.configService.localeKeys?.["where_to_watch.vodafone_tv.point4.text"]
      //   }
      // ]
    }
  ];
  
  this.mediaPlayerInfo= [
    {
      'device_name': this.configService.localeKeys?.["where_to_watch.android_tv.title"],
      'device_logo': this.deviceLogoUrl+'android-tv-logo.svg',
      'device_desc': this.configService.localeKeys?.["where_to_watch.android_tv_desc.part1.text"],
      'device_para': this.configService.localeKeys?.["where_to_watch.android_tv_desc.part2.text"],
      'device_main_img': 'https://www.youtube.com/embed/tgbNymZ7vqY?autoplay=1&mute=1',
      'type_slug': 'android_media',
      'image_name':'Android_TV',
      'image_type':'Android_TV',
      'device_steps': [
        {
          'stepImg': this.deviceUrl,
          'stespDesc': this.configService.localeKeys?.["where_to_watch.android_tv.point1.text"]
        },
        {
          'stepImg': this.deviceUrl,
          'stespDesc': this.configService.localeKeys?.["where_to_watch.android_tv.point2.text"]
        },
        {
          'stepImg': this.deviceUrl,
          'stespDesc': this.configService.localeKeys?.["where_to_watch.android_tv.point3.text"]
        },
        {
          'stepImg': this.deviceUrl,
          'stespDesc': this.configService.localeKeys?.["where_to_watch.android_tv.point4.text"]
        }
      ]
    },
    {
      'device_name': this.configService.localeKeys?.["where_to_watch.apple_tv.title"],
      'device_logo': this.deviceLogoUrl+'apple-tv-logo.svg',
      'device_desc': this.configService.localeKeys?.["where_to_watch.apple_tv_desc.part1.text"],
      'device_para': this.configService.localeKeys?.["where_to_watch.apple_tv_desc.part2.text"],
      'device_main_img': 'https://www.youtube.com/embed/tgbNymZ7vqY?autoplay=1&mute=1',
      'type_slug': 'apple_media',
      'image_name':'Apple_TV',
      'image_type':'Apple_TV',
      'device_steps': [
        {
          'stepImg': this.deviceUrl,
          'stespDesc': this.configService.localeKeys?.["where_to_watch.apple_tv.point1.text"]
        },
        {
          'stepImg': this.deviceUrl,
          'stespDesc': this.configService.localeKeys?.["where_to_watch.apple_tv.point2.text"]
        },
        {
          'stepImg': this.deviceUrl,
          'stespDesc': this.configService.localeKeys?.["where_to_watch.apple_tv.point3.text"]
        },
        {
          'stepImg': this.deviceUrl,
          'stespDesc': this.configService.localeKeys?.["where_to_watch.apple_tv.point4.text"]
        }
      ]
    },
    {
      'device_name': this.configService.localeKeys?.["where_to_watch.chromecast.title"],
      'device_logo': this.deviceLogoUrl+'chromecast.svg',
      'device_desc': this.configService.localeKeys?.["where_to_watch.chromecast_desc.text"],
      'device_para': this.configService.localeKeys?.["where_to_watch.chromecast_desc.text_part2"],
      'device_main_img': 'https://www.youtube.com/embed/tgbNymZ7vqY?autoplay=1&mute=1',
      'type_slug': 'chromecast_media',
      'image_name':'Chromecast',
      'image_type':'Chromecast',
      // 'device_steps': [
      //   {
      //     'stepImg': this.deviceUrl,
      //     'stespDesc': this.configService.localeKeys?.["where_to_watch.android_tv.point1.text"]
      //   },
      //   {
      //     'stepImg': this.deviceUrl,
      //     'stespDesc': this.configService.localeKeys?.["where_to_watch.android_tv.point2.text"]
      //   },
      //   {
      //     'stepImg': this.deviceUrl,
      //     'stespDesc': this.configService.localeKeys?.["where_to_watch.android_tv.point3.text"]
      //   },
      //   {
      //     'stepImg': this.deviceUrl,
      //     'stespDesc': this.configService.localeKeys?.["where_to_watch.android_tv.point4.text"]
      //   }
      // ]
    },
    {
      'device_name': this.configService.localeKeys?.["where_to_watch.airplay.title"],
      'device_logo': this.deviceLogoUrl+'airplay.svg',
      'device_desc': this.configService.localeKeys?.["where_to_watch.airplay_desc.text"],
      'device_para': this.configService.localeKeys?.["where_to_watch.airplay_desc.text_part2"],
      'device_main_img': 'https://www.youtube.com/embed/tgbNymZ7vqY?autoplay=1&mute=1',
      'type_slug': 'airplay_media',
      'image_name':'airplay',
      'image_type':'airplay',
      // 'device_steps': [
      //   {
      //     'stepImg': this.deviceUrl,
      //     'stespDesc': this.configService.localeKeys?.["where_to_watch.android_tv.point1.text"]
      //   },
      //   {
      //     'stepImg': this.deviceUrl,
      //     'stespDesc': this.configService.localeKeys?.["where_to_watch.android_tv.point2.text"]
      //   },
      //   {
      //     'stepImg': this.deviceUrl,
      //     'stespDesc': this.configService.localeKeys?.["where_to_watch.android_tv.point3.text"]
      //   },
      //   {
      //     'stepImg': this.deviceUrl,
      //     'stespDesc': this.configService.localeKeys?.["where_to_watch.android_tv.point4.text"]
      //   }
      // ]
    },
  ];
  
  this.smartphoneInfo = [
    {
      'device_name': this.configService.localeKeys?.["where_to_watch.ios.title"],
      'device_logo': this.deviceLogoUrl+'ios-mobile-logo.svg',
      'device_desc': this.configService.localeKeys?.["where_to_watch.ios_desc.part1.text"],
      'device_para': this.configService.localeKeys?.["where_to_watch.ios_desc.part2.text"],
      'device_main_img': 'https://www.youtube.com/embed/tgbNymZ7vqY?autoplay=1&mute=1',
      'type_slug': 'ios_phone',
      'image_name':'iOS',
      'image_type':'iOS',
      'device_steps': [
        {
          'stepImg': this.deviceUrl,
          'stespDesc': this.configService.localeKeys?.["where_to_watch.ios_desc.point1.text"]
        },
        {
          'stepImg': this.deviceUrl,
          'stespDesc': this.configService.localeKeys?.["where_to_watch.ios_desc.point2.text"]
        },
        {
          'stepImg': this.deviceUrl,
          'stespDesc': this.configService.localeKeys?.["where_to_watch.ios_desc.point3.text"]
        },
        {
          'stepImg': this.deviceUrl,
          'stespDesc': this.configService.localeKeys?.["where_to_watch.ios_desc.point4.text"]
        }
      ]
    },
    {
      'device_name': this.configService.localeKeys?.["where_to_watch.android.title"],
      'device_logo': this.deviceLogoUrl+'android-mobile-logo.svg',
      'device_desc': this.configService.localeKeys?.["where_to_watch.android_desc.part1.text"],
      'device_para': this.configService.localeKeys?.["where_to_watch.android_desc.part2.text"],
      'device_main_img': 'https://www.youtube.com/embed/tgbNymZ7vqY?autoplay=1&mute=1',
      'type_slug': 'android_phone',
      'image_name':'Android',
      'image_type':'Android_Mobile',
      'device_steps': [
        {
          'stepImg': this.deviceUrl,
          'stespDesc': this.configService.localeKeys?.["where_to_watch.android_desc.point1.text"]
        },
        {
          'stepImg': this.deviceUrl,
          'stespDesc': this.configService.localeKeys?.["where_to_watch.android_desc.point2.text"]
        },
        {
          'stepImg': this.deviceUrl,
          'stespDesc': this.configService.localeKeys?.["where_to_watch.android_desc.point3.text"]
        },
        {
          'stepImg': this.deviceUrl,
          'stespDesc': this.configService.localeKeys?.["where_to_watch.android_desc.point4.text"]
        }
      ]
    }
  ];
  }

  showContent(event, id){
    const selectedElem = event.srcElement.htmlFor;
    for (const property in this.contentData) {
      if (property === selectedElem) this.contentData[property] = true;
      else this.contentData[property] = false;
    }
    id.scrollIntoView({behavior: "smooth", block: "nearest", inline: 'center'});
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.isMobile = this.baseService.isMobileOrNot();
  }

  ngOnDestroy(): void {
    this.settingsService.showHeader = true;
  }

}
